import { useState, useContext, FC, useEffect } from "react";
import { SlotMachineContext, SocketContext, TeamContext, UserContext } from "../../../context";
import { useSound } from "../../../hooks";
import slotMachineLeverSprint from "../../../assets/images/slotMachineLeverSpring.png";
import slotmachineLeverWithGlow from "../../../assets/images/slotmachineLeverWithGlow.png";
import { PinkNotification } from "../../atoms";
import { useTranslation } from "react-i18next";

interface ISlotMachineSpinButton {
    setIsStrengthCardsInitialisationInvoked?(value: boolean): void;
    isInDemo?: boolean;
}

const SlotMachineSpinButton: FC<ISlotMachineSpinButton> = ({setIsStrengthCardsInitialisationInvoked, isInDemo}) => {
    const { t } = useTranslation();
    const { socket } = useContext(SocketContext);
    const { game } = useContext(TeamContext);
    const {
        confirmSelectionDisabled,
        isConfirmSelectionClicked, 
        generateFiveNewStrengthCardsManually,
        setGenerateFiveNewStrengthCardsManually,
        animateWhiteShaddowGlowingCards,
        setAnimateWhiteShaddowGlowingCards
    } = useContext(SlotMachineContext);
    const { userData } = useContext(UserContext);
    const [toggleLever, setToggleLever] = useState<boolean>(false);
    const [isArrowShown, setIsArrowShown] = useState<boolean>(true);
    const {playSound} = useSound();
    const pathname : string | undefined = window.location.pathname;
    const isPageSlotMachineDemoRendered : boolean = pathname.includes("/slotmachineDemoData");


    useEffect(() => {
        if (setIsStrengthCardsInitialisationInvoked && !(isArrowShown && !isConfirmSelectionClicked && confirmSelectionDisabled))
            setIsStrengthCardsInitialisationInvoked(true);

    }, [confirmSelectionDisabled, isArrowShown, isConfirmSelectionClicked, setIsStrengthCardsInitialisationInvoked]);

    const myEmail = localStorage["userEmailInCaseHeLogsOut"];

    useEffect(() => {
        const wasTheLeverPulledForTheFirstTime = !(isArrowShown && !isConfirmSelectionClicked && confirmSelectionDisabled);

        if (!userData) return;

        let userNicknameInLobby = game?.inGameLobby?.filter((lobby: any) => lobby?.email == myEmail)[0]?.nickname;
        let userInLobbyForStrengthCards = game?.gameInfo?.inGameLobby.filter((user: any) => user?.nickName === userNicknameInLobby)[0]?.currentStrengthCards;

        let currentStrengthCardsFromGameObject = !isInDemo ?  game?.gameInfo.players[userData?.email].currentStrengthCards : userInLobbyForStrengthCards;
        const numberOfSelectedStrengthCardsFromSlotMachine = currentStrengthCardsFromGameObject?.length;

        if ( wasTheLeverPulledForTheFirstTime && !animateWhiteShaddowGlowingCards && !numberOfSelectedStrengthCardsFromSlotMachine )
            setAnimateWhiteShaddowGlowingCards(true);

    }, [animateWhiteShaddowGlowingCards, confirmSelectionDisabled, game?.gameInfo.players, isArrowShown, isConfirmSelectionClicked, setAnimateWhiteShaddowGlowingCards, userData]);

    const spinButton = () => {
        const wasTheLeverPulledForTheFirstTime = !(isArrowShown && !isConfirmSelectionClicked && confirmSelectionDisabled);

        setIsArrowShown(false);

        setToggleLever(true);
        playSound("/sounds/LeverPull.mp3");

        if (animateWhiteShaddowGlowingCards && !wasTheLeverPulledForTheFirstTime)
            setAnimateWhiteShaddowGlowingCards(false);

        setTimeout(() => {
            setToggleLever!(false);
        }, 1000);

        if (isPageSlotMachineDemoRendered) {
            simulateGenerationOfNewStrengthCards();
            return;
        }

        if (isInDemo) {
            socket?.emit("generateRandomStrengthCardsNewPlayer");
            setTimeout(() => {
                socket?.emit("generateRandomStrengthCardsNewPlayer");
            }, 500);
        }

        if(!isInDemo) {
            socket?.emit("generateRandomStrengthCards");
            setTimeout(() => {
                socket?.emit("generateRandomStrengthCards");
            }, 500);
        }

        socket?.on("randomStrengthCards", (data) => {
            console.log("strength cards first 5 cards: ", data);
        });
    }



    useEffect( () => {
        socket?.emit("generateRandomStrengthCardsNewPlayer");
    }, [socket]); 
    const simulateGenerationOfNewStrengthCards = () => {
        setGenerateFiveNewStrengthCardsManually(!generateFiveNewStrengthCardsManually)
    }

    return (
        <div className="slot_machine_spin_lever_wrapper center_horizontally_and_vertically" >
            
            {!isInDemo &&isArrowShown && !isConfirmSelectionClicked && confirmSelectionDisabled && <div className="pull_theLlever_notification_wrapper"> 
               <PinkNotification notificationWidthVW={25} notificationRenderingSide="left" text={t("tipPullTheHandleToRevealTheStrengthCardsText")} moveFromTop={20} />
            </div>}

            <div className={`s_m_lever_image_wrapper ${isConfirmSelectionClicked && "opacity_08"}`} onMouseDown={spinButton}>
                {(isArrowShown && !isConfirmSelectionClicked && confirmSelectionDisabled) ?
                    <img
                        className={`stop_picture_dragging ${toggleLever ? "s_m_lever_sprint_image_animated" : "s_m_lever_sprint_image"} `}
                        src={slotmachineLeverWithGlow}
                        alt="lever"
                    />
                    :
                    <img
                        className={`stop_picture_dragging ${toggleLever ? "s_m_lever_sprint_image_animated" : "s_m_lever_sprint_image"} `}
                        src={slotMachineLeverSprint}
                        alt="lever"
                    />
                }
            </div>

        </div>
    )
}

export default SlotMachineSpinButton;